import React from 'react'
import cx from 'classnames'

export interface IButton extends React.HTMLAttributes<HTMLButtonElement> {
  variant: 'primary' | 'secondary'
  title: string
}

const Button = function ({ variant, className, title, ...props }: IButton) {
  return (
    <button className={cx('ocla-button', className, `${variant}`)} {...props}>
      {title}
    </button>
  )
}

export default React.memo(Button)
